import type { EControlType, IBaseControlSetting } from '~/presentation/reports/common/type';

import { AssetTemplateProvider } from '~/modules/asset-template';
import { SelectCampaignContent } from './SelectCampaignContent';
import { InlineStack, Box, Text } from '@shopify/polaris';
import { useSelectCampaignItem } from '../hooks';
import { cls } from '~/utils';

export interface IControlSelectCampaignItem extends IBaseControlSetting {
  type: EControlType.SELECT_CAMPAIGN_ITEM;
}

export const SelectCampaignItem: React.FC<IControlSelectCampaignItem> = (props) => {
  const { label, disabled, dependentControls, configs } = props;
  const { campaignGroupCampaigns, campaignGroupId } = useSelectCampaignItem({
    dependentControls,
    configs,
  });

  return (
    <AssetTemplateProvider campaigns={campaignGroupCampaigns}>
      <div
        className={cls('p-2 pl-7 pt-0', {
          'opacity-50': disabled,
        })}
      >
        <InlineStack align="space-between" wrap={false}>
          <Box minWidth="0">
            <InlineStack align={'space-between'} wrap={false}>
              <Text variant="bodySm" as="p" truncate>
                {label}
              </Text>
            </InlineStack>
          </Box>
        </InlineStack>
        <div className={cls('flex gap-[6px] mt-[6px] [&>*]:min-w-0')}>
          <SelectCampaignContent
            {...props}
            campaigns={campaignGroupCampaigns}
            campaignGroupId={campaignGroupId}
          />
        </div>
      </div>
    </AssetTemplateProvider>
  );
};
